import { render, staticRenderFns } from "./ModelGlobalMessage.vue?vue&type=template&id=79f8db4c&scoped=true"
import script from "./ModelGlobalMessage.vue?vue&type=script&lang=js"
export * from "./ModelGlobalMessage.vue?vue&type=script&lang=js"
import style0 from "./ModelGlobalMessage.vue?vue&type=style&index=0&id=79f8db4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f8db4c",
  null
  
)

export default component.exports